import type { IANATimezones, MonitoringDataSummaryResponse, ReviewTargets } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { MonitoringApi } from 'api/MonitoringApi';
import { MONITORING_DATA_SUMMARY_KEY } from 'hooks/keys';
import { DateTimeHelpers } from 'util/dateTime.util';
import { useUser } from './useUser';

export function useMonitoringDataSummary(
  startDate: string,
  endDate: string,
  targets: ReviewTargets,
  timezone: IANATimezones
) {
  const { userBankId } = useUser();
  const monitoringApi = new MonitoringApi();

  const formattedStartDate = DateTimeHelpers.formatISOToDateString(startDate, timezone);
  const formattedEndDate = DateTimeHelpers.formatISOToDateString(endDate, timezone);

  const {
    data: monitoringDataSummary,
    isLoading: isLoadingMonitoringDataSummary,
    isFetching: isFetchingMonitoringDataSummary
  } = useQuery<MonitoringDataSummaryResponse>({
    enabled: !!userBankId && !!targets && !!Object.keys(targets).length,
    queryKey: [MONITORING_DATA_SUMMARY_KEY, userBankId, formattedStartDate, formattedEndDate, targets],
    queryFn: () =>
      monitoringApi.getMonitoringDataSummary(userBankId, formattedStartDate, formattedEndDate, targets),
    meta: {
      snackbarErrorMessage:
        'There was an issue getting the data summary. Please contact support if the problem persists.'
    }
  });

  return { monitoringDataSummary, isLoadingMonitoringDataSummary, isFetchingMonitoringDataSummary };
}
